import React from 'react'
import { IconButton, Grid, Tooltip } from '@mui/material'
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck'
import { useLang } from '~/hooks/useLang'

export default function ListDispatchesButton({ listFullDispatchUrl }) {
  const { translate } = useLang()
  const ClickOpen = () => {
    window.open(
      listFullDispatchUrl,
      'list-despatches, width=auto, height=600, status = no'
    )
  }

  return (
    <Grid item>
      <Tooltip
        title={translate('See List Dispatches')}
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton onClick={ClickOpen}>
            <PlaylistAddCheckIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Grid>
  )
}
